var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBank({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 48,
    viewBox: "0 0 70 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 69,
    height: 47,
    rx: 5.5,
    fill: "white",
    stroke: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.1666 33.9167V38.1667H20.8333V33.9167C20.8333 33.1375 21.4708 32.5 22.2499 32.5H47.7499C48.5291 32.5 49.1666 33.1375 49.1666 33.9167Z",
    fill: "#E0A147",
    stroke: "#E0A147",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M29.3332 22.584H23.6665V32.5007H29.3332V22.584Z",
    fill: "#E0A147"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M35.0002 22.584H29.3335V32.5007H35.0002V22.584Z",
    fill: "#E0A147"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M40.6667 22.584H35V32.5007H40.6667V22.584Z",
    fill: "#E0A147"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M46.3332 22.584H40.6665V32.5007H46.3332V22.584Z",
    fill: "#E0A147"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5832 39.2285H19.4165C18.8357 39.2285 18.354 38.7468 18.354 38.166C18.354 37.5852 18.8357 37.1035 19.4165 37.1035H50.5832C51.164 37.1035 51.6457 37.5852 51.6457 38.166C51.6457 38.7468 51.164 39.2285 50.5832 39.2285Z",
    fill: "#E0A147"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2741 15.1459L35.5241 10.0459C35.2407 9.9326 34.7591 9.9326 34.4758 10.0459L21.7258 15.1459C21.2299 15.3442 20.8333 15.9251 20.8333 16.4634V21.1667C20.8333 21.9459 21.4708 22.5834 22.2499 22.5834H47.7499C48.5291 22.5834 49.1666 21.9459 49.1666 21.1667V16.4634C49.1666 15.9251 48.7699 15.3442 48.2741 15.1459ZM34.9999 19.0417C33.8241 19.0417 32.8749 18.0926 32.8749 16.9167C32.8749 15.7409 33.8241 14.7917 34.9999 14.7917C36.1758 14.7917 37.1249 15.7409 37.1249 16.9167C37.1249 18.0926 36.1758 19.0417 34.9999 19.0417Z",
    fill: "#E0A147"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank);
export default __webpack_public_path__ + "static/media/bank.e7d92ef5673c647f051ce08b9b8ee524.svg";
export { ForwardRef as ReactComponent };